import React, { useState, useRef } from 'react'
import Menu from './menu'
import { localestr, processFinishTo } from '../utils.js'
import icon from '../icons.svg';
let buffer = ''
let timer = null
let bloked = null

function Order({ wndData, catMenu, fldMenu, Rights, setWndData, consts, catReasons, catUsers, stoplist }) {
  const targetRef = useRef()
  const orderRef = useRef()
  const [anim, setAnim] = useState(0)
  let menu = []
  let tbl = []
  let qtt = 1
  let sumTotal = 0
  let sumDisc = 0
  let sumAdv = wndData.advance ? parseFloat(wndData.advance) : 0
  //let cardPay=0
  //let userFis=0
  //let userFisSet=0
  /*if(consts) {
      //cardPay=consts.constCardPay
      if(consts.constFisCash===3 || consts.constFisCard===3){
          //userFis=1
          //userFisSet=wndData.userFisSet || localStorage.getItem('user_fiscal') || 0
          //userFisSet=wndData.userFisSet || 0
          //userFisSet=parseInt(userFisSet)
      }
  }*/
  const Fld = wndData.parent || { id: null }
  const curent = wndData.curent === undefined ? -1 : wndData.curent
  function fldClick(f) {
    setWndData('parent', f)
  }

  function menuClick(f) {
    setAnim(1)
    setWndData('add', f)
  }

  function tblClick(f, status) {
    setWndData('curent', f)
  }

  function setQtt(f) {
    setWndData('setqtt', Math.max(0, f))
  }

  function tblClickPlusMinus(f, qtt) {
    if (f === curent) setQtt(qtt)
    else setTimeout(() => setQtt(qtt), 100)
  }

  function tblClickQtt(f) {
    if (f === curent) setWndData('calc', '')
    setTimeout(() => setWndData('calc', ''), 100)
    //setWndData('curent',f)
  }

  function tblClickQue(f) {
    if (f === curent) setWndData('setnom', '')
    setTimeout(() => setWndData('setnom', ''), 100)
    //setWndData('curent',f)
  }

  function kitchenClick() {
    setTimeout(() => bloked = null, 1000)
    if (bloked) return
    setWndData('kitchen', '')
    bloked = true
  }

  function precheckClick() {
    setTimeout(() => bloked = null, 1000)
    if (bloked) return
    setWndData('precheck', '')
    bloked = true
  }

  function getClass(idx, status, refuse, order_status = 0) {
    let plus = ''
    if (curent === idx) plus = 'selected '
    if (refuse && parseInt(refuse)) return plus + 'refuse'
    if (order_status) return plus + 'pay'
    if (parseInt(status) > 4) return plus + 'pay'
    if (parseInt(status) > 3) return plus + 'refuse'
    if (parseInt(status) > 2) return plus + 'done'
    if (parseInt(status) > 1) return plus + 'process'
    return plus
  }

  function getClassQue(idx, status, refuse, order_status = 0) {
    let plus = ''
    if (refuse && parseInt(refuse)) return plus + 'refuse'
    if (order_status && parseInt(status) > 1) return plus + 'pay'
    if (parseInt(status) > 4) return plus + 'pay'
    if (parseInt(status) > 3) return plus + 'refuse'
    if (parseInt(status) > 2) return plus + 'done'
    if (parseInt(status) > 1) return plus + 'process'
    return plus
  }

  function setVisible(el) {
    if (!el) return
    const rect = el.getBoundingClientRect()
    const p_rect = el.parentNode.getBoundingClientRect()
    if (rect.top + p_rect.height < p_rect.top + p_rect.height && rect.top >= p_rect.top) return
    //якщо треба покрутити
    if (anim === 1) el.scrollIntoView({ behavior: 'smooth' })
    else if (anim === 0) el.scrollIntoView()
    setAnim(-1)
  }

  function setActive(el) {
    if (!el) return
    if (document.activeElement.nodeName === 'INPUT') return
    if (document.activeElement.className === 'ord_cont') return
    el.focus()
  }

  function componentToHex(c) {
    if (c < 0) c = 0
    if (c > 255) c = 255
    let hex = c.toString(16)
    return hex.length === 1 ? "0" + hex : hex
  }
  function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b)
  }
  function hexToRgb(hex) {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null
  }

  //----------barcode---------
  const getSymbol = (e) => {
    if (e.target.tagName === 'INPUT') return
    if (e.key === 'Enter' || e.which === 13) {
      //console.log(buffer)
      if (!buffer) return
      let idx = -1
      const arr = menu.filter(el => el.barcode && el.barcode === buffer)
      if (arr.length === 1) idx = 0
      else if (arr.length > 1) {
        if (timer) clearInterval(timer)
        timer = null
        setWndData('add_arr', arr)
        return
      }
      if (idx === -1) { console.log(`Товар з кодом ${buffer} не знайдено`); }// msg('Товар з кодом '+buffer+' не знайдено!','Помилка',[{caption:'OK',action:()=>{}}])
      else {
        menuClick(arr[idx])
      }
      buffer = ''
      if (timer) clearInterval(timer)
      timer = null
      return
    }
    //alert(e.key)
    //alert(e.which)
    //if(buffer.length>12) alert(buffer)
    //if(!e.code) return
    buffer += e.key
    if (!timer) timer = setInterval(() => buffer = '', 500)
  }

  const amount_click = (el) => {
    if (!parseFloat(el.menu.price)) setWndData('price')
  }

  //-----------table---------
  if (catMenu) menu = catMenu
  if (wndData.docTable) tbl = wndData.docTable.sort((a, b) => {
    if (a.guest > b.guest) return 1
    if (a.guest < b.guest) return -1
    if (a.nom > b.nom) return 1
    if (a.nom < b.nom) return -1
    if (a.uid > b.uid) return 1
    if (a.uid < b.uid) return -1
    return 0
  })
  //console.log('tbl', wndData.docTable);
  const guest_bg = ['linear-gradient(to top, #22C55E11, #22C55E66)',
    'linear-gradient(to top, #EAB30811, #EAB30866)',
    'linear-gradient(to top, #8B5CF611, #8B5CF666)',
    'linear-gradient(to top, #F9731611, #F9731666)',
    'linear-gradient(to top, #3B82F611, #3B82F666)',
    'linear-gradient(to top, #EC489911, #EC489966)',
  ]
  const tblitems = []
  let que = 0
  let guest = 0
  let max_guest = 1
  for (let idx = 0; idx < tbl.length; idx++) {
    const el = { name: tbl[idx].menu ? tbl[idx].menu.name : tbl[idx].menu_name, ...tbl[idx], qtt: parseFloat(tbl[idx].qtt) }

    if (!el.refuse || parseInt(el.refuse) === 0) {
      sumDisc += parseFloat(el.discount || 0)
      sumTotal += parseFloat(el.amount || 0)
    }
    if (idx === curent) qtt = el.qtt
    const ex_mark1 = el.mark1 ? ((el.excise_mark || '').indexOf(el.mark1, 0) !== -1 ? <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'blue' }}>{' ' + el.mark1}</span> : <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'var(--dark-tx-color)' }}>{' (' + el.mark1 + ')'}</span>) : null
    const ex_mark2 = el.mark2 ? ((el.excise_mark || '').indexOf(el.mark2, 0) !== -1 ? <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'blue' }}>{' ' + el.mark2}</span> : <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'var(--dark-tx-color)' }}>{' (' + el.mark2 + ')'}</span>) : null
    const ex_mark3 = el.mark3 ? ((el.excise_mark || '').indexOf(el.mark3, 0) !== -1 ? <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'blue' }}>{' ' + el.mark3}</span> : <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'var(--dark-tx-color)' }}>{' (' + el.mark3 + ')'}</span>) : null
    const ex_mark4 = el.mark4 ? ((el.excise_mark || '').indexOf(el.mark4, 0) !== -1 ? <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'blue' }}>{' ' + el.mark4}</span> : <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'var(--dark-tx-color)' }}>{' (' + el.mark4 + ')'}</span>) : null
    const ex_mark5 = el.mark5 ? ((el.excise_mark || '').indexOf(el.mark5, 0) !== -1 ? <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'blue' }}>{' ' + el.mark5}</span> : <span style={{ fontStyle: 'italic', fontSize: 'small', color: 'var(--dark-tx-color)' }}>{' (' + el.mark5 + ')'}</span>) : null
    let plus_item = null
    let minus_item = null
    let qtt_item = el.qtt
    let modifiers = null
    if (el.modifiers) modifiers = el.modifiers.map(itm => <span key={itm.id} style={{ fontStyle: 'italic', fontSize: 'small', color: 'blue' }}><br />&nbsp;- {itm.name}</span>)
    const r_menu = []
    if (!el.comment) r_menu.push({ name: localestr('Додати коментар'), icon: '#btn5', action: () => { setWndData('coment', '') } })
    else r_menu.push({ name: localestr('Змінити коментар'), icon: '#btn5', action: () => { setWndData('coment', '') } })
    if ((parseInt(el.status) === 1 && (wndData.online || 0) < 2) || Rights.urAdmin) r_menu.push({ name: localestr('Змінити кількість'), icon: '#btn3', action: () => { setWndData('calc', '') } })

    if (el.menu?.modifiers) r_menu.push({ id: 'modifiers', name: localestr('Змінити модифікатори'), icon: '#btn14_', action: () => { setWndData('modifiers', '') } })
    if (el.menu && el.menu.ex_good1) r_menu.push({ id: 'ex_mark1', name: localestr('Акцизна марка 1'), icon: '#btn13', action: () => { setWndData('ex_mark1', '') } })
    if (el.menu && el.menu.ex_good2) r_menu.push({ id: 'ex_mark2', name: localestr('Акцизна марка 2'), icon: '#btn13', action: () => { setWndData('ex_mark2', '') } })
    if (el.menu && el.menu.ex_good3) r_menu.push({ id: 'ex_mark3', name: localestr('Акцизна марка 3'), icon: '#btn13', action: () => { setWndData('ex_mark3', '') } })
    if (el.menu && el.menu.ex_good4) r_menu.push({ id: 'ex_mark4', name: localestr('Акцизна марка 4'), icon: '#btn13', action: () => { setWndData('ex_mark4', '') } })
    if (el.menu && el.menu.ex_good5) r_menu.push({ id: 'ex_mark5', name: localestr('Акцизна марка 5'), icon: '#btn13', action: () => { setWndData('ex_mark5', '') } })


    if (consts.constQuePrint) r_menu.push({ name: localestr('Змінити чергу подачі'), icon: '#btn4', action: () => { tblClickQue() } })
    r_menu.push({ name: localestr('Змінити гостя'), icon: '#btn15', action: () => { setWndData('guest', '') } })
    if ((parseInt(el.status) === 1 && (wndData.online || 0) < 2) || Rights.urAdmin) r_menu.push({ name: localestr('Видалити рядок'), icon: '#btn2', action: () => { setWndData('setqtt', 0) } })
    const pull = <Menu left={false} data={r_menu}><div className='toolBarItem' title={localestr('Редагувати')}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + '#v_menu)', WebkitMaskImage: 'url(' + icon + '#v_menu)', margin: '0', color: 'var(--black-tx-color)' }}></div></div></Menu>
    //if(consts.constQuePrint) pull=<div className='toolBarItem' style={{fontStyle:'italic',fontSize:'small',color:'blue'}} onClick={()=>tblClickQue()}>{el.nom||''}</div>
    if ((parseInt(el.status) === 1 && (wndData.online || 0) < 2) || Rights.urAdmin) {
      plus_item = <div className='toolBarItem' title={localestr('Додати')} onClick={() => tblClickPlusMinus(idx, el.qtt + 1)}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + '#btn1)', WebkitMaskImage: 'url(' + icon + '#btn1)', margin: '0', color: 'var(--black-tx-color)' }}></div></div>
      minus_item = <div className='toolBarItem' title={localestr('Видалити')} onClick={() => tblClickPlusMinus(idx, el.qtt - 1)}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + '#btn2)', WebkitMaskImage: 'url(' + icon + '#btn2)', margin: '0', color: 'var(--black-tx-color)' }}></div></div>
      qtt_item = <div title={localestr('Ввести')} style={{ cursor: 'pointer' }} onClick={() => tblClickQtt(idx)}>{el.qtt}</div>
    }
    else if (parseInt(el.status) === 2 && el.menu && parseInt(el.menu.gravimetric || 0) && (wndData.online || 0) < 2) {
      qtt_item = <div title={localestr('Ввести')} style={{ cursor: 'pointer' }} onClick={() => tblClickQtt(idx)}>{el.qtt}</div>
    }

    if (wndData.guests > 1 && el.guest !== guest) {
      guest = el.guest
      if (guest > 1 && que) que = 99
      tblitems.push(<tr key={'g' + guest} className='tbl_guest'><td colSpan={6} style={{ background: guest_bg[(guest - 1) % guest_bg.length] }}>
        <div style={{ maskImage: 'url(' + icon + '#btn23)', WebkitMaskImage: 'url(' + icon + '#btn23)', margin: '1px 5px -1px 2px', backgroundColor: 'var(--black-tx-color)', width: '14px', height: '14px', display: 'inline-block' }}></div>{localestr('ГІСТЬ ') + guest}</td></tr>)
    }
    if (el.guest && el.guest > max_guest) max_guest = el.guest

    if ((el.nom > 1 || que) && el.nom !== que) {
      if (!que && idx && wndData.guests > 1) tblitems.splice(1, 0, <tr key={'g' + que + 'q' + 1} className={getClassQue(idx, el.status, el.refuse, wndData.status) + ' ord_que'}><td>{localestr('Черга подачі №') + 1}</td></tr>)
      else if (!que && idx) tblitems.unshift(<tr key={'g' + guest + 'q' + 1} className={getClassQue(idx, el.status, el.refuse, wndData.status) + ' ord_que'}><td>{localestr('Черга подачі №') + 1}</td></tr>)
      que = el.nom
      tblitems.push(<tr key={'g' + guest + 'q' + que} className={getClassQue(idx, el.status, el.refuse, wndData.status) + ' ord_que'}><td>{localestr('Черга подачі №') + que}</td></tr>)
    }

    if (idx === curent) tblitems.push(<tr key={idx} ref={el => { setVisible(el); return targetRef }} tabIndex='0' className={getClass(idx, el.status, el.refuse, wndData.status)} onClick={() => { tblClick(idx, el.status) }}><td>{el.name + (el.comment ? ' ' + el.comment : '')}{ex_mark1}{ex_mark2}{ex_mark3}{ex_mark4}{ex_mark5}{modifiers}</td><td>{minus_item}</td><td>{qtt_item}</td><td>{plus_item}</td><td onClick={() => amount_click(el)}>{el.amount}</td><td>{pull}</td></tr>)
    else tblitems.push(<tr key={idx} tabIndex='0' className={getClass(idx, el.status, el.refuse, wndData.status)} onClick={() => { tblClick(idx, el.status) }}><td>{el.name + (el.comment ? ' ' + el.comment : '')}{ex_mark1}{ex_mark2}{ex_mark3}{ex_mark4}{ex_mark5}{modifiers}</td><td>{minus_item}</td><td>{qtt_item}</td><td>{plus_item}</td><td onClick={() => amount_click(el)}>{el.amount}</td><td>{pull}</td></tr>)

  }
  //if(wndData.guests>guest && curent===99) {
  if (wndData.guest > guest && wndData.guest > 1 && curent === 99) {
    guest = wndData.guests
    if (wndData.guest) guest = wndData.guest
    tblitems.push(<tr key={'g' + guest} className='tbl_guest'><td colSpan={6} style={{ background: guest_bg[(guest - 1) % guest_bg.length] }}>
      <div style={{ maskImage: 'url(' + icon + '#btn23)', WebkitMaskImage: 'url(' + icon + '#btn23)', margin: '1px 5px -1px 2px', backgroundColor: 'var(--black-tx-color)', width: '14px', height: '14px', display: 'inline-block' }}></div>{localestr('ГІСТЬ ') + guest}</td></tr>)
  }

  //-----------menu---------
  let menu_folder = 'menu_folder'
  let menu_item = 'menu_item'
  let icons = false
  let wdth = null
  if (window.innerWidth >= 1290) {
    menu_folder = 'menu_folder big big2'
    menu_item = 'menu_item big big2'
    icons = true
    wdth = parseInt((window.innerWidth - 362) / parseInt((window.innerWidth - 362) / 240)) - 10
  }
  else if (window.innerWidth >= 600) {
    menu_folder = 'menu_folder big'
    menu_item = 'menu_item big'
    icons = true
    wdth = parseInt((window.innerWidth - 362) / parseInt((window.innerWidth - 362) / 220)) - 10
  }
  let menuitems = []
  let filteritems = []
  if (!fldMenu) fldMenu = []
  if (wndData.table && wndData.table.owner.goods) filteritems = fldMenu.filter(el => wndData.table.owner.goods === el.parent.id)
  filteritems = filteritems.concat(fldMenu.filter(el => filteritems.findIndex(it => it.id === el.parent.id) !== -1))
  let stl = null
  if (wdth) stl = { maxWidth: '' + wdth + 'px' }
  if (Fld.id && Fld.parent && Fld.parent.id) menuitems.push(<div key={menuitems.length} className={menu_folder} style={stl} onClick={() => { fldClick({ id: null }) }}><div>{localestr('На головну')}</div></div>)
  if (Fld.id && (!wndData.table || !wndData.table.owner.goods || wndData.table.owner.goods !== Fld.id)) menuitems.push(<div key={menuitems.length} className={menu_folder} style={stl} onClick={() => { fldClick(Fld.parent || { id: null }) }}><div>{localestr('Назад')}</div></div>)
  if (fldMenu) fldMenu.forEach(el => {
    let can_add = true
    if (wndData.table && wndData.table.owner.goods) {
      can_add = false
      if (wndData.table.owner.goods === el.id) can_add = true
      if (wndData.table.owner.goods === el.parent.id) can_add = true
      if (filteritems.findIndex(it => el.parent.id === it.id) !== -1) can_add = true
    }
    if (wndData.table && el.hall && wndData.table.owner.id !== el.hall) { }
    //else if(wndData.table&&wndData.table.owner.goods&&wndData.table.owner.goods!==el.id){}
    else if (el.parent && el.parent.id === Fld.id && can_add) {
      let icon = null
      if (icons) if (el.small_img) icon = <img src={el.small_img} alt='' />
      //--------color----------
      let stl = null
      let stl2 = null
      if (el.colour) {
        const color = hexToRgb(el.colour)
        if (color) {
          stl = { background: 'linear-gradient(0deg,' + rgbToHex(color.r - 38, color.g - 38, color.b - 38) + ',' + rgbToHex(color.r - 10, color.g - 10, color.b - 10) + ' 50%,' + rgbToHex(color.r + 28, color.g + 28, color.b + 28) + ')', borderColor: rgbToHex(color.r - 28, color.g - 28, color.b - 28) }
        }
      }
      if (window.innerWidth < 400) {
        if (el.name.length > 30) stl2 = { fontSize: '65%', lineHeight: '100%' }
      }
      if (wdth) {
        if (stl) stl.maxWidth = '' + wdth + 'px'
        else stl = { maxWidth: '' + wdth + 'px' }
      }
      menuitems.push(<div key={menuitems.length} className={menu_folder} style={stl} onClick={() => { fldClick(el) }}>{icon}<div style={stl2}>{el.name}</div></div>)
      //  menuitems.push(<div key={menuitems.length} className={menu_item} style={stl} onClick={()=>{menuClick(el)}}>{icon}<div>{prc_cont}<div style={stl1}><div style={stl2}>{el.name}</div></div></div></div>)
    }
  })
  //const stl1={height:'100%',overflow:'hidden',display:'flex',alignItems:'center'}
  const stl1 = { maxHeight: '100%', overflow: 'hidden' }
  menu.forEach(el => {
    let stop = null
    let stop_qtt = 0
    const menu_stop = stoplist.find(e => e.good === el.id)
    if (menu_stop) {
      if (menu_stop.qtt === 5) stop = <img style={{ position: 'absolute', width: '40px', height: '40px', right: '4px', margin: '0px' }} src={icon + '#stop5'} alt='' />
      else if (menu_stop.qtt === 4) stop = <img style={{ position: 'absolute', width: '40px', height: '40px', right: '4px', margin: '0px' }} src={icon + '#stop4'} alt='' />
      else if (menu_stop.qtt === 3) stop = <img style={{ position: 'absolute', width: '40px', height: '40px', right: '4px', margin: '0px' }} src={icon + '#stop3'} alt='' />
      else if (menu_stop.qtt === 2) stop = <img style={{ position: 'absolute', width: '40px', height: '40px', right: '4px', margin: '0px' }} src={icon + '#stop2'} alt='' />
      else if (menu_stop.qtt === 1) stop = <img style={{ position: 'absolute', width: '40px', height: '40px', right: '4px', margin: '0px' }} src={icon + '#stop1'} alt='' />
      else if (menu_stop.qtt < 1) stop = <img style={{ position: 'absolute', width: '40px', height: '40px', right: '4px', margin: '0px' }} src={icon + '#stop'} alt='' />
      if (menu_stop.qtt > 0) stop_qtt = menu_stop.qtt
    }
    if (el.parent && el.parent.id === Fld.id) {
      let icon = null
      if (icons) if (el.small_img) icon = <img src={el.small_img} alt='' />
      let stl = null
      let stl2 = null
      if (el.colour) {
        const color = hexToRgb(el.colour)
        if (color) {
          stl = { background: 'linear-gradient(0deg,' + rgbToHex(color.r - 38, color.g - 38, color.b - 38) + ',' + rgbToHex(color.r - 10, color.g - 10, color.b - 10) + ' 50%,' + rgbToHex(color.r + 28, color.g + 28, color.b + 28) + ')', borderColor: rgbToHex(color.r - 28, color.g - 28, color.b - 28) }
        }
      }
      if (window.innerWidth < 400) {
        const maxln1 = window.innerWidth * 0.0361 * 2 + 1
        const maxln2 = window.innerWidth * 0.0417 * 2 + 2
        if (el.name.length > maxln2) stl2 = { fontSize: '65%', lineHeight: '100%' }
        else if (el.name.length > maxln1) stl2 = { fontSize: '85%', lineHeight: '100%' }
      }
      if (wdth) {
        if (stl) stl.maxWidth = '' + wdth + 'px'
        else stl = { maxWidth: '' + wdth + 'px' }
      }
      let prc_cont = null
      if (el.price) prc_cont = <div>{el.price || ''}</div>
      if (el.special_price) prc_cont = <div style={{ color: '#F88', fontWeight: 'bold' }}>{el.price || ''}</div>
      if (stop && stop_qtt) menuitems.push(<div key={menuitems.length} className={menu_item} style={stl} onClick={() => { menuClick(el) }}>{icon}{stop}<div>{prc_cont}<div style={stl1}><div style={stl2}>{el.name}</div></div></div></div>)
      else if (stop) menuitems.push(<div key={menuitems.length} className={menu_item} style={stl}>{icon}{stop}<div>{prc_cont}<div style={stl1}><div style={stl2}>{el.name}</div></div></div></div>)
      else menuitems.push(<div key={menuitems.length} className={menu_item} style={stl} onClick={() => { menuClick(el) }}>{icon}<div>{prc_cont}<div style={stl1}><div style={stl2}>{el.name}</div></div></div></div>)
    }
    if (!el.parent && !Fld.id) {
      let icon = null
      if (icons) if (el.small_img) icon = <img src={el.small_img} alt='' />
      let stl = null
      if (el.colour) {
        const color = hexToRgb(el.colour)
        if (color) {
          stl = { background: 'linear-gradient(0deg,' + rgbToHex(color.r - 38, color.g - 38, color.b - 38) + ',' + rgbToHex(color.r - 10, color.g - 10, color.b - 10) + ' 50%,' + rgbToHex(color.r + 28, color.g + 28, color.b + 28) + ')', borderColor: rgbToHex(color.r - 28, color.g - 28, color.b - 28) }
        }
      }
      const prc_cont = el.price ? <div>{el.price || ''}</div> : null
      if (stop) menuitems.push(<div key={menuitems.length} className={menu_item} style={stl}>{icon}{stop}<div>{prc_cont}<div style={stl1}><div>{el.name}</div></div></div></div>)
      else menuitems.push(<div key={menuitems.length} className={menu_item} style={stl} onClick={() => { menuClick(el) }}>{icon}<div>{prc_cont}<div style={stl1}><div>{el.name}</div></div></div></div>)
    }
  })

  //-----------toolbar---------
  let toolbar = []
  let buttons = []
  let canClose = 1
  if (sumTotal === 0) canClose = 2
  else if (wndData.online === 2) canClose = 3
  else if (wndData.status === 3) canClose = 4
  else if (tblitems.length === 0) canClose = 0
  let maxButton = 9
  if (window.innerHeight < 600) maxButton = 0
  if (window.innerWidth <= window.innerHeight) {
    if (window.innerWidth >= 810) maxButton = 10
    else if (window.innerWidth >= 760) maxButton = 9
    else if (window.innerWidth >= 710) maxButton = 8
    else if (window.innerWidth >= 660) maxButton = 7
    else if (window.innerWidth >= 590) maxButton = 6
    else if (window.innerWidth >= 545) maxButton = 5
    else if (window.innerWidth >= 500) maxButton = 4
    else if (window.innerWidth >= 455) maxButton = 3
    else if (window.innerWidth >= 410) maxButton = 2
    else maxButton = 1
  }
  buttons.push({ id: 'precheck', name: localestr('Рахунок'), icon: '#btn7', action: () => { precheckClick() } })
  if (Rights.urDiscount || Rights.urAdmin) buttons.push({ id: 'discount', name: localestr('Знижка'), icon: '#btn8', action: () => { setWndData('discount', '') } })
  if (Rights.urDiscSum || Rights.urAdmin) buttons.push({ id: 'discount_sum', name: localestr('Знижка сумою'), icon: '#btn81', action: () => { setWndData('discount_sum', '') } })
  if (Rights.urReject || Rights.urAdmin) {
    if (consts && consts.constTurnTmpl) {
      if (curent !== -1 && wndData.docTable && wndData.docTable[curent]) {
        if (wndData.docTable[curent].refuse) buttons.push({ id: 'reject', name: localestr('Відмова'), icon: '#btn6', action: () => { setWndData('reject', '') } })
        else {
          if (catReasons && catReasons.length) {
            buttons.push({ id: 'reject2', name: localestr('Відмова'), icon: '#btn6', isFolder: true })
            catReasons.forEach(el => {
              buttons.push({ id: 'rj_' + el.id, name: el.name, icon: '#btn6', action: () => { setWndData('reject2', { ...el }) }, parent: 'reject2' })
            })
          }
        }
      } else {
        buttons.push({ id: 'reject', name: localestr('Відмова'), icon: '#btn6', action: () => { setWndData('reject', '') } })
      }
    } else buttons.push({ id: 'reject', name: localestr('Відмова'), icon: '#btn6', action: () => { setWndData('reject', '') } })
  }
  if (curent !== -1 && wndData.docTable) {
    if (wndData.docTable[curent] && wndData.docTable[curent]?.menu?.modifiers) buttons.push({ id: 'modifiers', name: localestr('Модифікатори'), icon: '#btn14_', action: () => { setWndData('modifiers', '') } })
    if (wndData.docTable[curent] && wndData.docTable[curent].menu && wndData.docTable[curent].menu.ex_good1) buttons.push({ id: 'ex_mark1', name: localestr('Акцизна марка'), icon: '#btn13', action: () => { setWndData('ex_mark1', '') } })
    if (wndData.docTable[curent] && wndData.docTable[curent].menu && wndData.docTable[curent].menu.ex_good2) buttons.push({ id: 'ex_mark2', name: localestr('Акцизна марка'), icon: '#btn13', action: () => { setWndData('ex_mark2', '') } })
    if (wndData.docTable[curent] && wndData.docTable[curent].menu && wndData.docTable[curent].menu.ex_good3) buttons.push({ id: 'ex_mark3', name: localestr('Акцизна марка'), icon: '#btn13', action: () => { setWndData('ex_mark3', '') } })
    if (wndData.docTable[curent] && wndData.docTable[curent].menu && wndData.docTable[curent].menu.ex_good4) buttons.push({ id: 'ex_mark4', name: localestr('Акцизна марка'), icon: '#btn13', action: () => { setWndData('ex_mark4', '') } })
    if (wndData.docTable[curent] && wndData.docTable[curent].menu && wndData.docTable[curent].menu.ex_good5) buttons.push({ id: 'ex_mark5', name: localestr('Акцизна марка'), icon: '#btn13', action: () => { setWndData('ex_mark5', '') } })
  }
  if (!wndData.docType) buttons.push({ id: 'table', name: localestr('Змінити стіл'), icon: '#btn12', action: () => { setWndData('table', '') } })
  else if (wndData.docType === 1) buttons.push({ id: 'address', name: localestr('Змінити адресу'), icon: '#btn22', action: () => { setWndData('address', '') } })
  else if (wndData.docType === 2) buttons.push({ id: 'pickup', name: localestr('Змінити адресу'), icon: '#btn22', action: () => { setWndData('pickup', '') } })
  else if (wndData.docType === 3) buttons.push({ id: 'banquet', name: localestr('Змінити стіл'), icon: '#btn12', action: () => { setWndData('banquet', '') } })

  /*if(userFis) {
  //console.log(userFisSet)
  if(userFisSet===0) buttons.push({id:'fiscal0',name:localestr('Фіскальний (Авто)'),icon:'#btn15a',action:()=>{setWndData('fiscal0','')}})
  else if(userFisSet===1) buttons.push({id:'fiscal1',name:localestr('Фіскальний'),icon:'#btn15f',action:()=>{setWndData('fiscal1','')}})
  else if(userFisSet===2) buttons.push({id:'fiscal2',name:localestr('Не фіскальний'),icon:'#btn15n',action:()=>{setWndData('fiscal2','')}})
}*/
  if (wndData.docTable && wndData.docTable.length > 0 && (Rights.urBreack || Rights.urAdmin)) buttons.push({ id: 'break', name: localestr('Розбити чек'), icon: '#btn14', action: () => { setWndData('break', '') } })
  //if(cardPay&&canClose===1) buttons.push({id:'card',name:localestr('Оплата карткою'),icon:'#btn9',action:()=>{setWndData('card','')}})
  const g_cont = <div style={{ position: 'absolute', top: '2px', right: '4px', fontSize: '14px', fontWeight: 'normal', lineHeight: '12px', textShadow: 'none', width: '14px', height: '14px', textAlign: 'center', color: '#00F' }}>{wndData.guests || '1'}</div>
  if (wndData.docType !== 1) buttons.push({ id: 'guests', name: localestr('Гості'), icon: '#btn15', content: g_cont, action: () => { setWndData('guests', '') } })
  buttons.push({ id: 'g_coment', name: localestr('Примітка'), icon: '#btn16', action: () => { setWndData('g_coment', '') } })
  if (wndData.docType === 1 && consts.constXprs && wndData.status < 2) buttons.push({ id: 'delivery', name: localestr('Передати в доставку'), icon: '#btn24', action: () => { setWndData('delivery', '') } })
  else if (wndData.docType === 1 && consts.constXprs && wndData.status > 1) buttons.push({ id: 'courier', name: localestr('Змінити кур\'єра'), icon: '#btn24', action: () => { setWndData('courier', '') } })
  if (catUsers) buttons.push({ id: 'author', name: localestr('Передати замовлення'), icon: '#b401', action: () => { setWndData('author', '') } })

  //console.log(wndData)
  const buttons2 = buttons.filter(el => el.id.substring(0, 3) !== 'rj_')
  maxButton = maxButton > buttons2.length ? buttons2.length : maxButton
  //console.log(maxButton)
  for (let i = 0; i < maxButton - 1; i++) {
    const button_id = buttons[0].id
    if (button_id === 'reject2') {
      const r_buttons = catReasons.map(el => ({ id: 'rj_' + el.id, name: el.name, icon: '#btn6', action: () => { setWndData('reject2', { ...el }) } }))
      toolbar.push(<Menu key={toolbar.length} data={r_buttons} stl={{ height: 'unset' }}><div className='ord_button toolBarItem' title={localestr('Відмова')}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + '#btn6)', WebkitMaskImage: 'url(' + icon + '#btn6)' }}></div></div></Menu>)
      //console.log([...buttons])
      buttons = buttons.filter(el => el.id.substring(0, 3) !== 'rj_')
    }
    else if (button_id === 'guests')
      toolbar.push(
        <div key={toolbar.length} style={{ position: 'relative' }} className='ord_button toolBarItem' title={buttons[0].name} onClick={() => { setWndData(button_id, '') }}>
          <div className='toolBarImg2' style={{ maskImage: 'url(' + icon + buttons[0].icon + ')', WebkitMaskImage: 'url(' + icon + buttons[0].icon + ')' }}></div>{buttons[0].content}</div>)
    else if (button_id.substring(0, 3) !== 'rj_')
      toolbar.push(<div key={toolbar.length} className='ord_button toolBarItem' title={buttons[0].name} onClick={() => { setWndData(button_id, '') }}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + buttons[0].icon + ')', WebkitMaskImage: 'url(' + icon + buttons[0].icon + ')' }}></div></div>)
    //console.log('s'+buttons[0].action)
    if (button_id.substring(0, 3) !== 'rj_') buttons.shift()
  }
  if (buttons.length > 1) {
    toolbar.push(<Menu key={toolbar.length} stl={{ height: 'unset' }} data={buttons}><div className='ord_button toolBarItem' title={localestr('Додатково')}><img src={icon + '#h_menu'} alt='' /></div></Menu>)
  } else if (buttons.length > 0) {
    const button_id = buttons[0].id
    if (button_id === 'guests')
      toolbar.push(
        <div key={toolbar.length} style={{ position: 'relative' }} className='ord_button toolBarItem' title={buttons[0].name} onClick={() => { setWndData(button_id, '') }}>
          <div className='toolBarImg2' style={{ maskImage: 'url(' + icon + buttons[0].icon + ')', WebkitMaskImage: 'url(' + icon + buttons[0].icon + ')' }}></div>{buttons[0].content}</div>)
    else
      toolbar.push(<div key={toolbar.length} className='ord_button toolBarItem' title={buttons[0].name} onClick={() => { setWndData(button_id, '') }}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + buttons[0].icon + ')', WebkitMaskImage: 'url(' + icon + buttons[0].icon + ')' }}></div></div>)
    buttons.shift()
  }
  if (Rights.urClose || Rights.urAdmin) {
    if (canClose === 0) toolbar.push(<div key={toolbar.length} className='ord_button2 toolBarItem toolBarItem2' title={localestr('Закрити')} onClick={() => { setWndData('q_close', '') }}>{localestr('Закрити')}</div>)
    else toolbar.push(<div key={toolbar.length} style={{ display: 'none' }} className='ord_button2 toolBarItem toolBarItem2' title={localestr('Закрити')} onClick={() => { setWndData('q_close', '') }}>{localestr('Закрити')}</div>)
    if (canClose === 1) toolbar.push(<div key={toolbar.length} className='ord_button2 toolBarItem toolBarItem2' title={localestr('Оплата')} onClick={() => { setWndData('q_pay', '') }}>{localestr('Оплата')}</div>)
    else if (canClose === 2) toolbar.push(<div key={toolbar.length} className='ord_button2 toolBarItem toolBarItem2' title={localestr('Закрити')} onClick={() => { setWndData('q_close', '') }}>{localestr('Закрити')}</div>)
    else if (canClose === 3) toolbar.push(<div key={toolbar.length} className='ord_button2 toolBarItem toolBarItem2' title={localestr('Закрити')} onClick={() => { setWndData('q_online', '') }}>{localestr('Закрити')}</div>)
    else if (canClose === 4) toolbar.push(<div key={toolbar.length} className='ord_button2 toolBarItem toolBarItem2' title={localestr('Закрити')} onClick={() => { setWndData('q_online3', '') }}>{localestr('Закрити')}</div>)
    else toolbar.push(<div key={toolbar.length} style={{ display: 'none' }} className='ord_button2 toolBarItem toolBarItem2' title={localestr('Оплата')} onClick={() => { setWndData('q_pay', '') }}>{localestr('Оплата')}</div>)
  }
  //console.log(sumDisc)
  let ttl = localestr('Всього') + ': ' + (sumTotal - sumAdv).toFixed(2)
  if (wndData.online === 2) ttl = localestr('Оплачено онлайн') + ': ' + sumTotal.toFixed(2)
  if (wndData.status === 3 && wndData.payType === 0) ttl = localestr('Готівкою') + ': ' + sumTotal.toFixed(2)
  if (wndData.status === 3 && wndData.payType === 1) ttl = localestr('Карткою') + ': ' + sumTotal.toFixed(2)
  if (sumDisc) ttl = ttl + '\n' + localestr('в т. ч. знижка ') + sumDisc.toFixed(2)
  if (sumAdv) ttl = ttl + '\n' + localestr('в т. ч. аванс ') + sumAdv.toFixed(2)
  if (wndData.online === 2 || wndData.status === 3) ttl = <span style={{ color: '#008800' }}>{ttl}</span>
  else ttl = <span style={{ color: 'var(--black-tx-color)' }}>{ttl}</span>
  const today = (new Date()).toLocaleString().substring(0, 10)
  const orderDate = (new Date(wndData.date)).toLocaleString()
  let ttl2 = (new Date(wndData.open || wndData.date)).toLocaleString()
  if ((new Date()) < (new Date(wndData.date))) ttl2 = 'На ' + orderDate.substring(0, 17)
  else if (today === ttl2.substring(0, 10)) ttl2 = ttl2.substring(12, 17)
  else ttl2 = ttl2.substring(0, 17)
  if (wndData.id) ttl2 += ' ' + localestr('№') + wndData.id
  if (wndData.docType === 0) ttl2 += ' ' + (wndData.table?.name || '') + ' ' + (wndData.table?.owner?.name || '')
  if (wndData.phone) ttl2 += ' ' + localestr('тел. ') + wndData.phone
  if (wndData.name) ttl2 += ' ' + wndData.name
  if (wndData.address) ttl2 = ttl2 + '\n' + wndData.address
  if (!ttl2 && wndData.discount) ttl2 = wndData.discount.name || ''
  if (ttl2 && wndData.comment) ttl2 = ttl2 + '\n' + wndData.comment
  else if (wndData.comment) ttl2 = '' + wndData.comment
  if (wndData.status > 1) ttl2 = ttl2 + '\n' + localestr('в доставці')
  if (wndData.courier_name) ttl2 = ttl2 + ' ' + wndData.courier_name + ' (' + wndData.reward + ')'
  if (wndData.time_spent) {
    const hours = Math.floor(wndData.time_spent / 60); // Отримуємо цілі години
    const minutes = wndData.time_spent % 60;
    ttl2 += `\n Тривалість візиту: ${hours}:${minutes.toString().padStart(2, '0')}год`
  }

  /*const today=(new Date()).toISOString()
  const doc_date=wndData.date||null
  if(doc_date>today){
      if(ttl2) ttl2=ttl2+'\n'+localestr('на ')+(new Date(doc_date)).toLocaleString()
      else ttl2=localestr('на ')+(new Date(doc_date)).toLocaleString()
  }*/
  let ttl3 = '';
  if (wndData.finish_to) {
    if (String(wndData.finish_to).includes('#')) {
      //let ind = String(wndData.finish_to).indexOf('#');
      if (wndData.docType === 2) {
        ttl2 = ttl2 + "\nПриготувати через: "
      } else if (wndData.docType === 1) {
        ttl2 = ttl2 + "\nДоставити через: "
      } else if (wndData.docType === 3) {
        ttl2 = ttl2 + "\nПриготувати до: "
      }
    } else {
      if (wndData.docType === 2) {
        ttl2 = ttl2 + "\nПриготувати на: " + String(wndData.finish_to).replace(/-/g, '.')
      } else if (wndData.docType === 1) {
        ttl2 = ttl2 + "\nДоставити на: " + String(wndData.finish_to).replace(/-/g, '.')
      } else if (wndData.docType === 3) {
        ttl2 = ttl2 + "\nПриготувати на: " +
          new Date(wndData.finish_to).toLocaleString('uk-UA');
      }
      // if (wndData.finish_to) ttl3 = processFinishTo(String(wndData.finish_to))
      if (wndData.finish_to && String(wndData.finish_to).length < 7) ttl3 = processFinishTo(String(wndData.finish_to))
    }
  }

  if (ttl2) ttl2 = <div style={{ fontWeight: 'bold', whiteSpace: 'pre-wrap', padding: '0 2px', color: 'var(--black-tx-color)' }}>{ttl2}{ttl3}</div>
  let tulbar1 = <div className={'ord_toolbar'} >
    {/*<div className='ord_button toolBarItem' title={localestr('Додати')} onClick={()=>{setQtt(qtt+1)}}><img src={icon+'#btn1'} alt='' /></div>*/}
    <div className='ord_button toolBarItem' title={localestr('Додати')} onClick={() => { setQtt(qtt + 1) }}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + '#btn1)', WebkitMaskImage: 'url(' + icon + '#btn1)' }}></div></div>
    <div className='ord_button toolBarItem' title={localestr('Видалити')} onClick={() => { setQtt(qtt - 1) }}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + '#btn2)', WebkitMaskImage: 'url(' + icon + '#btn2)' }}></div></div>
    <div className='ord_button toolBarItem' title={localestr('Ввести')} onClick={() => { setWndData('calc', '') }}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + '#btn3)', WebkitMaskImage: 'url(' + icon + '#btn3)' }}></div></div>
    <div className='ord_button toolBarItem' title={localestr('Коментар')} onClick={() => { setWndData('coment', '') }}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + '#btn5)', WebkitMaskImage: 'url(' + icon + '#btn5)' }}></div></div>
    <div className='ord_button toolBarItem' title={localestr('Готувати')} onClick={kitchenClick}><div className='toolBarImg2' style={{ maskImage: 'url(' + icon + '#btn4)', 'WebkitMaskImage': 'url(' + icon + '#btn4)' }}></div></div>
    {toolbar}
  </div>

  //let add_guest=<div className={'ord_guest'} onClick={e=>setWndData('guests',wndData.guests+1)} >
  let add_guest = <div className={'ord_guest'} onClick={e => setWndData('guests', (wndData.guest || 1) + 1)} >
    <div style={{ maskImage: 'url(' + icon + '#btn23)', WebkitMaskImage: 'url(' + icon + '#btn23)', margin: '1px 5px -1px 2px', backgroundColor: '#00F', width: '14px', height: '14px', display: 'inline-block' }}></div>{localestr('ДОДАТИ ГОСТЯ')}
  </div>
  if (!tbl.length) add_guest = null
  else if (tbl[tbl.length - 1].guest < (wndData.guest || 1)) add_guest = null

  let tulbar2 = null
  return (
    <div className={'ord_cont'} tabIndex='0' onKeyUp={getSymbol} ref={el => { setActive(el); return orderRef }}>
      <div className={'tbl_cont'} >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {ttl2}
          {(!wndData.advance && Rights.urAdvance) && (<div key={toolbar.length} style={{ width: '160px', minWidth: '100px' }} className='ord_button2 toolBarItem toolBarItem2' title={localestr('Взяти аванс')} onClick={() => { setWndData('advance', '') }}>{localestr('Взяти аванс')}</div>)}
        </div>
        {tulbar1}
        <div className={'ord_table'} ><table>
          <thead><tr><th>{localestr('Назва')}</th><th colSpan={3} style={{ minWidth: '84px' }}>{localestr('К-сть')}</th><th>{localestr('Сума')}</th><th></th></tr></thead><tbody>
            {tblitems}
          </tbody></table>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            {add_guest}
            <div className={'ord_caption'} >{ttl}</div>
          </div>
        </div>

      </div>
      <div className={'menu_cont'} >
        {menuitems}
      </div>
      {tulbar2}
    </div>
  )
}

export default Order